(function() {

    'use strict';



    var mimeTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif'
    ];

    var arrIndexOf = SAPO.Utility.arrIndexOf;



    function ImageBuilder(item, parentEl) { // receives StaticResource
        var aEl = document.createElement('a');
        aEl.setAttribute('href', item.companionClickThrough);
        aEl.setAttribute('target', '_blank');
        //aEl.setAttribute('', '');

        var iEl = document.createElement('img');
        iEl.setAttribute('src',    item.src);
        iEl.setAttribute('width',  item.dims[0]);
        iEl.setAttribute('height', item.dims[1]);

        aEl.appendChild(iEl);
        parentEl.appendChild(aEl);
    }



    function ImageHdlr(item) {
        if (
            item.nodeName !== 'StaticResource' ||
            arrIndexOf(mimeTypes, item.type) === -1
        ) { return; }


        return {
            mimeType:    item.type,
            description: 'non-linear image',
            item:        item,
            builder:     ImageBuilder
        };
    }



    SAPO.Project.Video.VAST.handlers.Image = ImageHdlr;

})();
